import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/spinner.svg'


const _withScopeId = n => (_pushScopeId("data-v-5d35d1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "error-text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DragAndDropUploader = _resolveComponent("DragAndDropUploader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DragAndDropUploader, {
      files: _ctx.uploadFiles,
      onOnAddFiles: _ctx.addFiles,
      onOnDeleteFile: _ctx.deleteFile,
      allowedTypes: ['pdf']
    }, null, 8, ["files", "onOnAddFiles", "onOnDeleteFile"]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      id: "submitButton"
    }, "Submit"),
    _hoisted_1,
    (!_ctx.valid)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.validationMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "spinner",
      class: _normalizeClass({ show: _ctx.spinner })
    }, _hoisted_4, 2)
  ]))
}